export const SPECIMEN_STATUS_ID = Object.freeze({
	ACTIVO: 1,
	VENDIDO: 2,
	MUERTO: 3,
	REGALADO: 4,
	PRESTADO: 5,
	ENFERMERIA: 6,
	EXTRAER: 7,
	ANULADO: 8,
	MUDA: 9,
	PREPARACION: 10,
	DONADO: 11,
	PREPOSTURA: 12,
	HERIDO: 13,
	CULECA: 15,
	EN_POSTURA: 16,
	EN_CUIDO: 17,
	DISPUESTO: 18,
	RECUPERACION: 19,
	LISIADO: 20,
	DEPURADO: 21,
	RETORNADO: 22,
})
